import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Card, Flex, Form, InputNumber, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import { TicketData } from "../..";
import { Kanban_State, Priority } from "../../../../js/parsegenerated";
import { TicketStateTag } from "./TicketStateTag";

type Props = {
  ticketData: TicketData;
  priority: Priority;
  nextState: Kanban_State;
};

export const StateFormItem = (props: Props) => {
  const t = useTranslation();

  return (
    <Card
      key={props.ticketData.ticket.id}
      title={
        <Typography.Text strong>
          {props.ticketData.ticket.title}
        </Typography.Text>
      }
    >
      <Form.Item
        label={
          <Flex
            gap={"8px"}
            align="center"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <Typography.Text strong>{"Statusaktualisierung"}</Typography.Text>
            <TicketStateTag state={props.ticketData.state} />
            <Icon icon="fa:arrow-right" />
            <TicketStateTag state={props.nextState} />
          </Flex>
        }
        rules={[{ required: false }]}
        name={"description_" + props.ticketData.ticket.id} // is later used on save to get the ticket id
      >
        <TextArea
          rows={4}
          placeholder={t("maintenance:ticket.move.form.description.label")}
        />
      </Form.Item>
      <Form.Item
        label={
          <Flex
            gap={"8px"}
            align="center"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <Typography.Text strong>{`Prio`}</Typography.Text>
          </Flex>
        }
        name={"priority_" + props.ticketData.ticket.id} // is later used on save to get the ticket id
      >
        <InputNumber
          min={0}
          max={100}
          placeholder={`Aktuell: ${props.priority?.value ?? 0}`}
          style={{ width: "100%" }}
        />
      </Form.Item>
    </Card>
  );
};
